/** Stub for CDN bundle */
export function decode(str) {
  if (typeof str !== 'string') return str;
  const div = typeof document !== 'undefined' ? document.createElement('div') : null;
  if (div) {
    div.innerHTML = str;
    return div.textContent ?? div.innerText ?? str;
  }
  return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
}
export default { decode };
